import React from 'react';
import cx from 'classnames';
import { range } from 'lodash';
import Link from 'next/link';
import { Icon } from '@scentregroup/ui';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const generatePages = (currentPage, totalPages) => {
  const maxPageButtons = 5; // checks if current page is out of range

  let page = currentPage;

  if (currentPage < 0) {
    page = 0;
  } else if (currentPage > totalPages) {
    page = totalPages - 1;
  }

  let startPage = 0;
  let endPage = totalPages;

  if (totalPages >= maxPageButtons) {
    const medianPageDivisor = 2;
    const numberOfPagesBeforeCurrentPage = Math.floor(maxPageButtons / medianPageDivisor);
    const numberOfPagesAfterCurrentPage = Math.ceil(maxPageButtons / medianPageDivisor);

    if (page <= numberOfPagesBeforeCurrentPage) {
      startPage = 0;
      endPage = maxPageButtons;
    } else if (page + numberOfPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPageButtons;
      endPage = totalPages;
    } else {
      startPage = page - numberOfPagesBeforeCurrentPage;
      endPage = page + numberOfPagesAfterCurrentPage;
    }
  }

  return range(startPage, endPage);
};
export const LinkPagination = _ref => {
  let {
    currentPage,
    totalPages,
    makePageLink,
    onLinkClick
  } = _ref;

  const onLinkClick_ = onLinkClick || (() => undefined);

  const pages = generatePages(currentPage, totalPages);
  const onFirstPage = currentPage === 0;
  const onLastPage = totalPages - 1 === currentPage;
  return /*#__PURE__*/_jsxs("div", {
    className: style.paginationWrapper,
    "data-id": "pagination_index_LinkPagination_div",
    children: [onFirstPage ? /*#__PURE__*/_jsx("span", {
      className: cx(style.button, style.disabledLink),
      "data-id": "pagination_index_LinkPagination_span",
      children: /*#__PURE__*/_jsx(Icon, {
        type: 'chevron-left',
        size: "small",
        "data-id": "pagination_index_LinkPagination_span_Icon"
      })
    }) : /*#__PURE__*/_jsx(Link, {
      passHref: true,
      href: makePageLink(currentPage - 1),
      prefetch: false,
      "data-id": "pagination_index_LinkPagination_Link",
      children: /*#__PURE__*/_jsx("a", {
        className: style.button,
        href: makePageLink(currentPage - 1),
        "aria-label": "Go to previous page",
        onClick: () => onLinkClick_(currentPage - 1),
        "data-id": "pagination_index_LinkPagination_Link_a",
        children: /*#__PURE__*/_jsx(Icon, {
          type: 'chevron-left',
          size: "small",
          "data-id": "pagination_index_LinkPagination_a_Icon"
        })
      })
    }), pages.map(page => /*#__PURE__*/_jsx(Link, {
      passHref: true,
      href: makePageLink(page),
      prefetch: false,
      "data-id": "pagination_index_LinkPagination_Link",
      children: /*#__PURE__*/_jsx("a", {
        href: makePageLink(page),
        "aria-label": "Go to page ".concat(page + 1),
        className: cx(style.button, {
          [style.isCurrentPage]: page === currentPage
        }),
        onClick: () => onLinkClick_(page),
        "data-id": "pagination_index_LinkPagination_Link_a",
        children: page + 1
      })
    }, "go-to-page-".concat(page + 1))), onLastPage ? /*#__PURE__*/_jsx("span", {
      className: cx(style.button, style.disabledLink),
      "data-id": "pagination_index_LinkPagination_span",
      children: /*#__PURE__*/_jsx(Icon, {
        type: 'chevron-right',
        size: "small",
        "data-id": "pagination_index_LinkPagination_span_Icon"
      })
    }) : /*#__PURE__*/_jsx(Link, {
      passHref: true,
      href: makePageLink(currentPage + 1),
      prefetch: false,
      "data-id": "pagination_index_LinkPagination_Link",
      children: /*#__PURE__*/_jsx("a", {
        className: style.button,
        href: makePageLink(currentPage + 1),
        "aria-label": "Go to next page",
        onClick: () => onLinkClick_(currentPage + 1),
        "data-id": "pagination_index_LinkPagination_Link_a",
        children: /*#__PURE__*/_jsx(Icon, {
          type: 'chevron-right',
          size: "small",
          "data-id": "pagination_index_LinkPagination_a_Icon"
        })
      })
    })]
  });
};
export const Pagination = _ref2 => {
  let {
    currentPage,
    totalPages,
    onChange
  } = _ref2;
  const pages = generatePages(currentPage, totalPages);
  const onFirstPage = currentPage === 0;
  const onLastPage = totalPages - 1 === currentPage;
  return /*#__PURE__*/_jsxs("div", {
    className: style.paginationWrapper,
    "data-id": "pagination_index_LinkPagination_div",
    children: [/*#__PURE__*/_jsx("button", {
      className: style.button,
      "aria-label": "Go to previous page",
      disabled: onFirstPage,
      onClick: () => onChange(currentPage - 1),
      "data-id": "pagination_index_LinkPagination_div_button",
      children: /*#__PURE__*/_jsx(Icon, {
        type: 'chevron-left',
        size: "small",
        "data-id": "pagination_index_LinkPagination_button_Icon"
      })
    }), pages.map(page => /*#__PURE__*/_jsx("button", {
      "aria-label": "Go to page ".concat(page + 1),
      className: cx(style.button, {
        [style.isCurrentPage]: page === currentPage
      }),
      onClick: () => onChange(page),
      "data-id": "pagination_index_LinkPagination_button",
      children: page + 1
    }, "go-to-page-".concat(page + 1))), /*#__PURE__*/_jsx("button", {
      className: style.button,
      "aria-label": "Go to next page",
      disabled: onLastPage,
      onClick: () => onChange(currentPage + 1),
      "data-id": "pagination_index_LinkPagination_div_button_17",
      children: /*#__PURE__*/_jsx(Icon, {
        type: 'chevron-right',
        size: "small",
        "data-id": "pagination_index_LinkPagination_button_Icon"
      })
    })]
  });
};